module.exports = __webpack_public_path__ + "img/largura_apoios.2cff4198.png";